import(/* webpackMode: "eager" */ "/app/src/app/tools/chart-recommender/page.tsx");
